export const TextAlignmentClasses = {
    LEFT: ['wf-text-left'],
    CENTER: ['wf-text-center'],
    RIGHT: ['wf-text-right'],
    JUSTIFY: ['wf-text-justify']
}